/**
 * list with urgent notifications
 * extends admin-dashboard-list-base view
 **/
import BaseView from '../admin-dashboard-list-base/view';
import EventBus from '../../utils/eventbus';
import SocketEvents from '../../events/socket';
import ListItemView from './item/view';

export default BaseView.extend({

	initialize: function() {
		// call BaseView constructor
		var collectionData = window.data.notifications || null;
		BaseView.prototype.initialize.apply(this, [collectionData]);

		// reference elements
		this.countEl = this.query(this.el, '.js-notification-count');

		// listen to new notifications, call BaseView method
		this.listenTo(EventBus, SocketEvents.ADMINNOTIFICATION, this.onNotificationReceived);
	},

	/**
	 * BaseView override
	 * list item view differs from the one used in BaseView
	 **/
	renderListItem: function(model) {
		return new ListItemView({
			model: model
		}).render();
	},

	/**
	 * BaseView override
	 * also update the counter in the DOM
	 **/
	onNotificationAdded: function(model, collection) {
		this.updateCounter();

		BaseView.prototype.onNotificationAdded.apply(this, [model, collection]);
	},

	/**
	 * BaseView override
	 * also update the counter in the DOM
	 **/
	onNotificationRemoved: function(model, collection) {
		this.updateCounter();
		BaseView.prototype.onNotificationRemoved.apply(this, [model, collection]);
	},

	// update counter in DOM with number of models in collection
	updateCounter: function() {
		this.countEl.textContent = this.collection.length;
	}

});
